// Validation check fields for GroupEligibility (Type 2)
export const validationCheckFields = [
    { key: 'validation_ActionType', label: 'Action Type' },
    {
        key: 'validation_ApplicationRole',
        label: 'Application Role',
    },
    {
        key: 'validation_AccountStore',
        label: 'Account Store',
    },
    {
        key: 'validation_EligibilityType',
        label: 'Eligibility Type',
    },
    {
        key: 'validation_AssigneeType',
        label: 'Assignee Type',
    },
    {
        key: 'validation_Assignee',
        label: 'Assignee',
    },
    { key: 'validation_AssignmentExists', label: 'Assignment Exists' },
]

